function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSettings = function SvgSettings(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    viewBox: "0 0 1.333 1.333"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h1.333v1.333H0z",
    style: {
      fill: "#25b7d3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.59.367A.16.16 0 0 0 .424.332l.11.109.017.062L.506.55.443.532.334.422a.155.155 0 0 0 .198.2l.225.225A.128.128 0 1 0 .85.755L.625.53A.16.16 0 0 0 .59.367M.94.82.962.9l-.06.059-.08-.022-.021-.08.058-.06z",
    style: {
      fill: "#ececec"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.633.673.838.468V.412l.135-.07.028.027-.067.134-.06.005L.662.72z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.649.642a.02.02 0 0 0-.031 0L.577.683.572.678C.556.662.534.685.526.693L.342.877c-.037.066.06.167.124.124L.65.817C.658.81.68.787.665.771L.66.766.7.725a.02.02 0 0 0 0-.031z",
    style: {
      fill: "#df2c2c"
    }
  }));
};
export default SvgSettings;